jQuery(function($) {
	var key = "AIzaSyCIONORnbp8YqK39niVfSFjN62JHqq76mU";
	var playlistId = "PLosygs97JZxorOguQJWEPoGdE1sL9-MhB";
	var URL = "https://www.googleapis.com/youtube/v3/playlistItems";

	var PageToken = "";
	var options = {
		part: "snippet",
		key: key,
		maxResults: 6,
		pageToken: PageToken,
		playlistId: playlistId
	};

	var isMobile = window.matchMedia("only screen and (max-width: 760px)");



	function loadVids(){
		$.getJSON(URL, options, function(data) {
			var id = data.items[0].snippet.resourceId.videoId;
			resultsLoop(data);
			pageToken = data.nextPageToken;
			options.pageToken = pageToken;
		});
	}

	function animateTabs(){
		$(".tabsNew").animate({ height: $("#Videoklipp").height() + 300}, 500);
	}

	var numOfItems = 0;
	function resultsLoop(data) {
		$.each(data.items, function(i, item) {
            var thumb = item.snippet.thumbnails.medium.url;
            var title = item.snippet.title;
            var vid = item.snippet.resourceId.videoId;
            $("#Videoklipp").append('<div class="new' + (i+1) + ' col-12 col-sm-6 col-lg-4"><a href="https://www.youtube.com/embed/' + (vid) + '" class="wplightbox video" data-group="gallery0" data-width="1000" data-height="600" title="' + (title) + '" data-thumbnail="' + (thumb) + '"><img src="' + (thumb) + '"></a></div>');
			numOfItems++;
		});
		if (numOfItems != data.pageInfo.totalResults) {
			$("#Videoklipp").append(
				'<div class="col-12"><a class="btn btn-secondary occident-read-more-link loadMoreVideo">Ladda in fler</a></div>'
			);
		}
		$(".loadMoreVideo").on("click", function() {
			$(this).remove();
			loadVids();
			setTimeout(animateTabs, 500);
        });
        jQuery(".wplightbox").wonderpluginlightbox();
	}
	$(".loadMoreVideos").on("click", function() {
		var container = $(this).parent().parent();
		var thisEl = $(this).parent();
		var button = $(this),
		    data = {
			'action': 'loadMoreVideos',
			'loaded': loadedVideos,
			'max' : maxNumOfVideos
		};
		$.ajax({
			url : '/wp-admin/admin-ajax.php',
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Laddar...');
			},
			success : function( data ) {
				if( data ) { 
					container.append(data);
					container.append(thisEl);
					thisEl.append(button);
					button.text( 'Ladda in fler' );
					setTimeout(animateTabs, 500);
					jQuery(".wplightbox").wonderpluginlightbox();
					loadedVideos = loadedVideos+v;
					if ( loadedVideos >= maxNumOfVideos ) 
						button.remove();
				} else {
					console.log("false");
				}
			},
			error : function( error ) {
				console.log(error);
			}
		});
	});

	$("body").one("click", "#tab4-content", function(){
		//loadVideos();
		if (isMobile.matches) {
			$(".tabsNew").animate({ height: 1600 }, 500);
		} else {
			$(".tabsNew").animate({ height: $("#Videoklipp").height() + 200 }, 500);
		}
	});


	if(window.location.pathname == '/nyheter-och-press/' && location.hash.length > 1) {
		var hash_tag = location.hash;
		if(hash_tag.length > 0) {
			$('.tab-label-content label').each(function(i,el) {
				if('#'+$(this).html().toLowerCase() == hash_tag && hash_tag == '#videoklipp') {
					$('input[id="tab4"]').prop('checked',true);
					$('input[id="tab1"]').removeAttr('checked');
					//loadVids();
					if (isMobile.matches) {
						$(".tabsNew").animate({ height: 1600 }, 500);
					} else {
						$(".tabsNew").animate({ height: $("#Videoklipp").height() + 200 }, 500);
					}
				}
			});
		}
	}
});
